import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {HttpService} from "../../services/http/http.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";

@Component({
  selector: 'app-rifiuta-profilo',
  templateUrl: './rifiuta-profilo.component.html',
  styleUrls: ['./rifiuta-profilo.component.scss'],
  imports: [
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
  ],
  standalone: true
})
export class RifiutaProfiloComponent {

  constructor(
    public dialogRef: MatDialogRef<RifiutaProfiloComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {idProposta: number, idProfilo: number},
    public api : HttpService,
    public snackBar : MatSnackBar
  ) { }

  step : number = 1;
  get title(): string {
    return this.step === 1 ? 'Rifiuta profilo' : 'Rifiuta competenze associate';
  }

  get message(): string {
    return this.step === 1 ? 'Sei sicuro di voler rifiutare il profilo?' : 'Desideri rifutare anche le competenze in stato di bozza associate al profilo rifiutato?';
  }

  handleClick() {

    if(this.step === 1){
      this.api.rifiutaProfilo({valore: this.data.idProposta}).subscribe({
        next: (res: any) => {
          this.snackBar.open('Profilo rifiutato', 'close', {panelClass: 'successSnack'});
          this.api.profileHasDraftCompetences({valore : this.data.idProfilo}).subscribe({
            next: (response: any) => {
              if(!response.result.booleano){
                this.closeDialog(true);
                return;
              }

              this.step = 2;
            }
          })
        }
      })
    }else{
      this.api.rifiutaCompetenzeByIdProfilo(this.data.idProfilo).subscribe({
        next : (res : any) => {
          this.snackBar.open(res.messaggio, 'close', {panelClass: 'successSnack'});
          this.dialogRef.close(true);
        }
      })
    }
  }

  closeDialog(refresh : boolean, rejectedCompetences : boolean=false): void {
    if(this.step === 2 && !rejectedCompetences){
      this.snackBar.open('Le competenze non rifiutate in stato di bozza saranno disponibili nella funzionalità GESTIONE COMPETENZE', 'close', {panelClass: 'successSnack'});
    }
    this.dialogRef.close(refresh || this.step === 2);
  }
}
